import type { Kurulum, TarafKurulumu } from '@kurultay/savas'
import type { Meslek, Durus } from '@kurultay/tipler'

function taraf(ad: string, meslek: Meslek, durus: Durus): TarafKurulumu {
  return {
    kahraman: {
      ad, meslek, baslangicDurusu: durus,
      can: 620, saldiri: 92, zirh: 100, ruhDirenci: 60,
      hiz: 32, kritikSansi: 0.15, isabet: 210, kacinma: 70,
    },
    ceriler: [
      { ceriTuru: 'piyade', adet: 20, can: 26, saldiri: 42, zirh: 70, ruhDirenci: 25, hiz: 20, saf: 'on' },
      { ceriTuru: 'okcu',   adet: 15, can: 19, saldiri: 55, zirh: 25, ruhDirenci: 25, hiz: 26, saf: 'arka' },
    ],
  }
}

export interface DemoSecenegi {
  kod: string
  etiket: string
  kurulum: Kurulum
  /** Savaşın geçtiği yer — arka plan levhasını belirler. */
  fon: string
}

export const DEMOLAR: DemoSecenegi[] = [
  {
    kod: 'alp',
    etiket: 'Alp — Kılıç + Balta',
    fon: 'dest_i_kipcak',
    kurulum: { a: taraf('Bilge', 'alp', 'kilic'), b: taraf('Tomris', 'akinci', 'ok') },
  },
  {
    kod: 'akinci',
    etiket: 'Akıncı — Ok + Bıçak',
    fon: 'otuken_ormani',
    kurulum: { a: taraf('Tomris', 'akinci', 'ok'), b: taraf('Bilge', 'alp', 'kilic') },
  },
  {
    kod: 'kam',
    etiket: 'Kam — Büyü + Şifa',
    fon: 'otuken_ormani',
    kurulum: { a: taraf('Ozan', 'kam', 'buyu'), b: taraf('Bilge', 'alp', 'kilic') },
  },
  {
    kod: 'kargici',
    etiket: 'Kargıcı — Tırpan + Cirit',
    fon: 'dest_i_kipcak',
    kurulum: { a: taraf('Cündi', 'kargici', 'tirpan'), b: taraf('Bilge', 'alp', 'kilic') },
  },
]
